// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\"> <path d=\"M128,0A128,128,0,1,0,256,128,128,128,0,0,0,128,0Zm0,232A104,104,0,1,1,232,128,104,104,0,0,1,128,232Z\"/> </svg>";
// Exports
module.exports = code;